import { Button, Modal, Text, TextArea } from '@viapeople/components'
import type React from 'react'
import { useState } from 'react'

interface DeclineReasonDialogProps {
	isOpen: boolean
	onClose: () => void
	onConfirm: (reason?: string) => void
	isSubmitting?: boolean
	requireReason?: boolean
}

export const DeclineReasonDialog: React.FC<DeclineReasonDialogProps> = ({
	isOpen,
	onClose,
	onConfirm,
	isSubmitting = false,
	requireReason = false,
}) => {
	const [declineReason, setDeclineReason] = useState('')

	const handleConfirm = () => {
		onConfirm(declineReason.trim() || undefined)
	}

	const isReasonEmpty = !declineReason.trim()
	const isConfirmDisabled = isSubmitting || (requireReason && isReasonEmpty)

	const handleClose = () => {
		setDeclineReason('')
		onClose()
	}

	return (
		<Modal title='Decline task' isOpen={isOpen} onClose={handleClose} className='max-w-lg'>
			<div className='p-6'>
				<div className='mb-4'>
					<Text variant='medium' className='text-neutral-600'>
						Are you sure you want to decline this task?{' '}
						{requireReason
							? 'Please provide a reason for declining.'
							: 'You can optionally provide a reason for declining.'}
					</Text>
				</div>

				<div className='mb-6'>
					<label htmlFor='decline-reason' className='block mb-2'>
						<Text variant='small' weight='regular' className='text-neutral-700'>
							Decline reason {requireReason ? '(required)' : '(optional)'}
						</Text>
					</label>
					<TextArea
						id='decline-reason'
						value={declineReason}
						onChange={(e) => setDeclineReason(e.target.value)}
						placeholder='Enter reason for declining...'
						className='w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 resize-none'
						rows={4}
					/>
				</div>

				<div className='flex gap-3 justify-end'>
					<Button variant='secondary' onClick={handleClose}>
						Cancel
					</Button>
					<Button variant='destructive' onClick={handleConfirm} disabled={isConfirmDisabled}>
						{isSubmitting ? 'Declining...' : 'Decline'}
					</Button>
				</div>
			</div>
		</Modal>
	)
}
